export default "__VITE_ASSET___uZorkhx__"